function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from 'react';
import { bool, func, node, shape, string } from 'prop-types';
import { styled } from '@mui/material/styles';
import Stack from '@mui/material/Stack';
import assetResolver, { assetKeys } from 'mosaic-assets-resolver';
import SovosLink from '../sovos-link';
import SovosDialog from '../sovos-dialog';
import SovosDialogContent from '../sovos-dialog-content';
import SovosTypography from '../sovos-typography';
import { square } from '../internals/utils';
import useMosaicTranslation from '../internals/i18n/useMosaicTranslation';
import CloseButton from '../internals/components/close-button/CloseButton';
const Title = styled('div')(() => ({
  alignItems: 'flex-start',
  display: 'flex',
  flexWrap: 'wrap',
  justifyContent: 'space-between'
}));
const Logo = styled('div')(_ref => {
  let {
    theme: {
      spacing
    }
  } = _ref;
  return {
    '& img': {
      height: spacing(2.5)
    },
    height: spacing(2.5)
  };
});
const Content = styled(SovosDialogContent)(_ref2 => {
  let {
    theme: {
      spacing
    }
  } = _ref2;
  return {
    margin: "".concat(spacing(3), " 0")
  };
});
const ProductIcon = styled('div')(_ref3 => {
  let {
    theme: {
      spacing
    }
  } = _ref3;
  return {
    marginInlineStart: spacing(8),
    '& img': {
      ...square(spacing(15))
    }
  };
});
const SovosAboutThisDialog = _ref4 => {
  let {
    description,
    labels,
    learnMoreUrl,
    onClose,
    open = false,
    privacyPolicyUrl,
    productIconUrl,
    productName,
    termsAndConditionsUrl,
    versionNumber,
    ...rest
  } = _ref4;
  const {
    t
  } = useMosaicTranslation();
  return /*#__PURE__*/React.createElement(SovosDialog, _extends({
    onClose: onClose,
    open: open
  }, rest), /*#__PURE__*/React.createElement(Title, null, /*#__PURE__*/React.createElement(Stack, {
    gap: 1,
    useFlexGap: true
  }, /*#__PURE__*/React.createElement(Logo, {
    className: ""
  }, /*#__PURE__*/React.createElement("img", {
    src: assetResolver.branding(assetKeys.branding.logoDark),
    alt: "Sovos Logo"
  })), /*#__PURE__*/React.createElement(SovosTypography, {
    fontWeight: "600",
    variant: "h5"
  }, productName), versionNumber && /*#__PURE__*/React.createElement(SovosTypography, {
    color: "text.secondary"
  }, "".concat((labels === null || labels === void 0 ? void 0 : labels.version) || t('aboutThis.version'), " ").concat(versionNumber))), /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(CloseButton, {
    onClose: onClose,
    tooltipText: (labels === null || labels === void 0 ? void 0 : labels.close) || t('dialogTitle.closeDialogTooltip'),
    size: "small"
  }))), /*#__PURE__*/React.createElement(Content, null, /*#__PURE__*/React.createElement(Stack, {
    alignItems: "flex-start",
    direction: "row",
    justifyContent: "space-between"
  }, description, /*#__PURE__*/React.createElement(ProductIcon, null, /*#__PURE__*/React.createElement("img", {
    src: productIconUrl !== null && productIconUrl !== void 0 ? productIconUrl : assetResolver.branding(assetKeys.branding.iconLarge),
    alt: "".concat(productName, " logo")
  })))), /*#__PURE__*/React.createElement(Stack, {
    alignItems: "flex-start",
    direction: "row",
    gap: 3
  }, learnMoreUrl && /*#__PURE__*/React.createElement(SovosLink, {
    href: learnMoreUrl,
    target: "_blank"
  }, "".concat((labels === null || labels === void 0 ? void 0 : labels.learnMore) || t('aboutThis.learnMore'), " ").concat(productName)), privacyPolicyUrl && /*#__PURE__*/React.createElement(SovosLink, {
    href: privacyPolicyUrl,
    target: "_blank"
  }, (labels === null || labels === void 0 ? void 0 : labels.privacyPolicy) || t('aboutThis.privacyPolicy')), termsAndConditionsUrl && /*#__PURE__*/React.createElement(SovosLink, {
    href: termsAndConditionsUrl,
    target: "_blank"
  }, (labels === null || labels === void 0 ? void 0 : labels.termsAndConditions) || t('aboutThis.termsAndConditions'))));
};
SovosAboutThisDialog.propTypes = {
  description: node.isRequired,
  labels: shape({
    close: string,
    learnMore: string,
    privacyPolicy: string,
    termsAndConditions: string,
    version: string
  }),
  learnMoreUrl: string,
  onClose: func.isRequired,
  open: bool,
  privacyPolicyUrl: string,
  productIconUrl: string,
  productName: string.isRequired,
  termsAndConditionsUrl: string,
  versionNumber: string
};
export default SovosAboutThisDialog;